import { Request } from 'api';
import { AxiosResponse } from 'axios';
import { AthletePod } from '../../app.types';

type ReturnType = Promise<AxiosResponse<Array<AthletePod>>>;

const getAthletePods = (): ReturnType => Request.get(`/athlete-users/pods/my-pods`);

export default getAthletePods;
